import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Clover, ArrowLeft } from "lucide-react";
import { AdminTab } from "../components/tabs/AdminTab";
import { api } from "../lib/api";

export default function AdminPage() {
  const navigate = useNavigate();
  const [game, setGame] = useState("loto");
  const [draws, setDraws] = useState([]);
  const [affiliate, setAffiliate] = useState({});

  const loadDraws = useCallback(async (g) => {
    try {
      const { data } = await api.get(`/draws/${g}`);
      setDraws(data.draws || []);
    } catch {
      setDraws([]);
    }
  }, []);

  const loadAffiliate = useCallback(async () => {
    try {
      const { data } = await api.get("/affiliate-links");
      setAffiliate(data.links || {});
    } catch {
      setAffiliate({});
    }
  }, []);

  useEffect(() => { loadDraws(game); }, [game, loadDraws]);
  useEffect(() => { loadAffiliate(); }, [loadAffiliate]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="sticky top-0 z-50 bg-[#0B132B] text-white px-4 sm:px-6 py-3.5 flex items-center justify-between shadow-md">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center text-[#0B132B] bg-white shadow">
            <Clover className="w-5 h-5" />
          </div>
          <div className="leading-none">
            <div className="font-black text-lg tracking-tight">ProbaLoto · Admin</div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-white/50">Espace réservé</div>
          </div>
        </div>
        <button onClick={() => navigate("/")} className="inline-flex items-center gap-1.5 text-sm font-bold text-white/80 hover:text-white transition-colors" data-testid="admin-back-home">
          <ArrowLeft className="w-4 h-4" /> Retour au site
        </button>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <AdminTab
          game={game}
          onGame={setGame}
          draws={draws}
          affiliate={affiliate}
          onChanged={() => loadDraws(game)}
          onAffiliateChanged={loadAffiliate}
        />
      </main>
    </div>
  );
}
